module.exports = __webpack_public_path__ + "img/banner-21.c2fc76f6.jpg";